<template>
  <details 
    ref="dropdown" 
    :class="['dropdown dropdown-end z-[60]', customClass]" 
    :open="open"
  >
    <summary :class="overrideLabelClass ? labelClass : ['btn btn-info btn-base', labelClass]"   @click.prevent="toggle">
      <slot name="label">
        {{ label }}
      </slot>
    </summary>
    <div @click="(e) => {
  const parent = e.target.closest('ul')
  if (parent) close()
}">
      <slot />
    </div>
  </details>

  <div v-if="open" class="fixed inset-0 bg-transparent z-[50]" @click="close" />
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  label: { type: String, default: window.i18n['Action'] },
  labelClass: { type: [String, Object], default: '' },
  customClass: { type: [String, Object], default: '' },
  overrideLabelClass: { type: Boolean, default: false }
})

const emit = defineEmits(['select'])

const open = ref(false)

const toggle = () => {
  if (!open.value) window.dispatchEvent(new CustomEvent('close-all-dropdowns'))
  open.value = !open.value
}
const close = () => { open.value = false }

onMounted(() => {
  window.addEventListener('close-all-dropdowns', close)
})

onBeforeUnmount(() => {
  window.removeEventListener('close-all-dropdowns', close)
});
</script>
